<template>
	<div v-if="activeWidget">
		<template v-if="activeWidget.content.type == 'map' && activeWidget.content.data && activeWidget.content.data.myMap">
			<MyTabs
				:tabs="tabs"
				:data="activeWidget.content.data"
			/>
		</template>
	</div>
</template>

<script>
	import MyTabs from "./MyTabs";

	export default {
		computed: {
			activeWidget: {
				get: function(){
					return this.$store.state.activeWidget;
				}
			}
		},
		data: function(){
			var data = {
				tabs: [{
					title: "Mano objektai",
					component: "my-objects"
				},{
					title: "Turinys",
					component: "map-layers"
				},{
					title: "Paieška",
					component: "service-search"
				},{
					title: "Nustatymai",
					component: "settings"
				}]
			};
			return data;
		},
		components: {
			MyTabs
		}
	}
</script>